(window.BWFeaturePosts = function ($, Behaviors) {
    "use strict";

    const module = {};
    const swipers = new WeakMap();

    function debounce(callback, delay) {
        let timeoutHandler = null;
        return function () {
            clearTimeout(timeoutHandler);
            timeoutHandler = setTimeout(function () {
                callback();
            }, delay);
        };
    }

    const initSwiper = module => {
        const swiperSettings = {
            slidesPerView: 1,
            spaceBetween: 0,
            pagination: {
                el: module.querySelector('.bw-featured-posts-slider-pagination'),
                type: 'bullets',
                clickable: true,
            },
            loop: true,
            speed: 500,
            breakpoints: {
                768: {
                    loop: true,
                    slidesPerView: 1.8,
                    spaceBetween: 20,
                    scrollbar: {
                        dragSize: 300
                    },
                },
            },
        };

        const swiper = new Swiper(module, swiperSettings);
        swipers.set(module, swiper);
    };

    const destroySwiper = module => {
        const swiper = swipers.get(module);
        if (swiper instanceof Swiper && swiper.destroy) {
            swiper.destroy();
            swipers.delete(module);
        }
    };


    function BWFeaturePosts() {
        const logoModules = document.querySelectorAll('.bw-featured-posts-slider');

        if (!logoModules.length) {
            return;
        }

        logoModules.forEach(module => {
            if (window.innerWidth < 1200) {
                if (!swipers.has(module)) {
                    initSwiper(module);
                }
            } else {
                if (swipers.has(module)) {
                    destroySwiper(module);
                }
            }
        });
    }

    function featuredPostsNavigation() {
        const navigations = document.querySelectorAll('.bwPostsNavigation');

        if (!navigations.length) return;

        navigations.forEach(nav => {
            const parent = nav.parentElement;
            const items = parent.querySelectorAll('.bw-featured-posts-holder');

            nav.addEventListener('click', e => {
                const { target } = e;

                if (!target.matches('li')) return;

                // Remove 'active' class from any other element
                const activeElements = nav.querySelectorAll('.active');
                activeElements.forEach(activeElement => {
                    activeElement.classList.remove('active');
                });

                // Add 'active' class to the current target element
                target.classList.add('active');

                const activeFilter = target.dataset.fpIndex;

                //Handle toggling of sections
                items.forEach(item => {
                    if (activeFilter === 'all' || activeFilter === item.dataset.fpIndex) {
                        item.style.display = 'flex';
                    } else {
                        item.style.display = 'none';
                    }
                });
            });
        });
    }


    module.BWFeaturePosts = BWFeaturePosts;

    document.addEventListener('DOMContentLoaded', () => {
        BWFeaturePosts();
        featuredPostsNavigation();
    });


    window.addEventListener('resize', debounce(function () {
        BWFeaturePosts();
    }, 300));

    return module;

}(window.jQuery, window.Behaviors))

